import React from 'react';
import { Button } from '../../common';
import type { ConnectionStatus, FlowState } from '../../../types/whatsapp';

export interface ConnectionActionsProps {
  flowState: FlowState;
  connectionStatus: ConnectionStatus;
  onConnect: () => void;
  onCancel: () => void;
  onRetry: () => void;
}

export const ConnectionActions: React.FC<ConnectionActionsProps> = ({
  flowState,
  connectionStatus,
  onConnect,
  onCancel,
  onRetry
}) => {
  const getButtonText = () => {
    if (connectionStatus.isConnected) {
      return 'Desconectar';
    }
    
    if (flowState.isLoading) {
      return 'Conectando...';
    }
    
    if (flowState.cancelled || flowState.error) {
      return 'Reintentar Conexión';
    }
    
    return 'Iniciar conexión con';
  };

  const handleButtonClick = () => {
    if (flowState.cancelled || flowState.error) {
      onRetry();
    } else {
      onConnect();
    }
  };

  if (connectionStatus.isConnected) {
    return null;
  }

  return (
    <>
      {/* Loading Progress */}
      {flowState.isLoading && (
        <div className="p-0 mb-6">
          <div className="flex items-center gap-3 mb-4">
            <h3 className="text-sm font-semibold text-[#424242]">Proceso en curso</h3>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-[#6150AD] h-2 rounded-full transition-all duration-500 animate-pulse"
              style={{ width: '45%' }}
            />
          </div>
          <p className="text-sm font-normal text-[#424242] mt-4">
            Por favor, completa el proceso en la ventana de Facebook que se abrió.
          </p>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex gap-3 justify-center">
        {!connectionStatus.isConnected && (
          <div className="flex justify-center">
            <button
              onClick={handleButtonClick}
              disabled={flowState.isLoading}
              className="flex items-center justify-center gap-2 px-8 py-3 text-white font-semibold text-base transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              style={{
                backgroundColor: flowState.isLoading ? "#dcdcdc" : '#6150AD',
                borderRadius: '60px',
                maxWidth: '336px',
                height: '54px',
                width: '100%'
              }}
              onMouseEnter={(e) => {
                if (!flowState.isLoading) {
                  e.currentTarget.style.backgroundColor = '#5041a0';
                }
              }}
              onMouseLeave={(e) => {
                if (!flowState.isLoading) {
                  e.currentTarget.style.backgroundColor = '#6150AD';
                }
              }}
            >
              {flowState.isLoading ? (
                <span className="text-[#888888] text-sm">Conectando...</span>
              ) : (
                <>
                  <span>Iniciar conexión con</span>
                  <img 
                    src="/Meta_Logo.svg" 
                    alt="Meta" 
                    className="w-[62px] h-[12px] brightness-0 invert"
                  />
                </>
              )}
            </button>
          </div>
        )}

        {flowState.isLoading && (
          <Button
            variant="outline"
            onClick={onCancel}
            className="w-[150px] h-[54px] rounded-[60px]"
          >
            Cancelar
          </Button>
        )}

        {(flowState.cancelled || flowState.error) && (
          <Button
            variant="primary"
            icon="refresh-cw"
            onClick={onRetry}
          >
            Reintentar
          </Button>
        )}
      </div>
    </>
  );
};